import Tjenestepanel from './Tjenestepanel';

globalThis.TjenestepanelComponents = {
  Tjenestepanel,
};
